import $ from 'jquery';

export default class Accordion {
  constructor(selector) {
    this.selector = selector;
    this.init();
  }

  init() {
    $(this.selector).each(function () {
      const that = $(this);

      $(this).find('[data-accordion-title]').click(function () {
        const hideAccordion = that.find('[data-accordion-body]').is(':visible');

        // Hide all accordions (including the one ticked)
        $('[data-accordion-body]').hide();
        $('[data-accordion-title]').removeClass('active');

        if (!hideAccordion) {
          // Show the clicked accordion if necessary
          $(this).addClass('active');
          that.find('[data-accordion-body]').show();

          that.trigger('accordion:opened');
        }
      });
    });
  }
}
